<template>
  <div class="flex flex-col gap-12 md:flex-row">
    <BackupRadio
      v-for="(offer, index) in filteredOffers"
      :id="createIdentifier(offer.id)"
      :key="createIdentifier(offer.id)"
      class="pt-10 only-of-type:w-full"
      :data-qa="`insurance-offer-${index}`"
      :is-selected="selectedOfferId === offer.id"
      :offer
      :tracking-zone
      @remove="emit('remove')"
      @select="emit('select', offer)"
    >
    </BackupRadio>

    <BackupPlusRadio
      :id="createIdentifier(backupPlusOffer.id)"
      :key="createIdentifier(backupPlusOffer.id)"
      class="pt-10 only-of-type:w-full"
      :is-selected="selectedOfferId === backupPlusOffer.id"
      :offer="backupPlusOffer"
      :tracking-zone
      @remove="emit('remove')"
      @select="emit('select', backupPlusOffer)"
    >
    </BackupPlusRadio>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { InsuranceOffer } from '@backmarket/http-api'

import { DEFAULT_INSURANCE_ID } from '~/scopes/insurance/constants'

import BackupPlusRadio from './components/BackupPlusRadio/BackupPlusRadio.vue'
import BackupRadio from './components/BackupRadio/BackupRadio.vue'

const props = defineProps<{
  offers: InsuranceOffer[]
  trackingZone: string
  id: string
  selectedOfferId?: number | string
  backupPlusOffer: InsuranceOffer
}>()

const emit = defineEmits<{
  select: [insuranceOffer: InsuranceOffer]
  remove: []
}>()

const filteredOffers = computed(() => {
  return props.offers.filter(
    (offer) =>
      !offer.isCatchUpOffer &&
      offer.id.toString() !== DEFAULT_INSURANCE_ID &&
      !offer.isBackupPlus,
  )
})

function createIdentifier(offerId: number | string) {
  return props.id + offerId
}
</script>
